import { render, staticRenderFns } from "./InfoInlineFrame.vue?vue&type=template&id=0a2c6a2c&"
import script from "./InfoInlineFrame.vue?vue&type=script&lang=js&"
export * from "./InfoInlineFrame.vue?vue&type=script&lang=js&"
import style0 from "./InfoInlineFrame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports